import React from 'react';
import { Article } from 'libs/microcms';
import { Box, Flex, Text, AspectRatio, LinkBox } from '@chakra-ui/react';
import striptags from 'striptags';
import Link from 'next/link';
import { paths } from 'constants/paths';
import { formatDate } from 'utils/date';

interface Props {
  articles: Article[];
}

export const BlogArticles: React.FC<Props> = ({ articles }) => (
  <Flex flexWrap="wrap" m="0 -16px">
    {articles.map((article) => (
      <Box
        key={article.slug}
        width={{
          base: '100%',
          md: '352px',
        }}
        mb="32px"
        p="0 16px"
      >
        <LinkBox _hover={{ opacity: 0.8 }}>
          <Link href={paths.blogDetail({ blogFriendlyId: article.slug })}>
            <AspectRatio
              position="relative"
              display="flex"
              justifyContent="center"
              ratio={40 / 21}
              width="100%"
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img style={{ borderRadius: '16px' }} src={article.image.url} />
            </AspectRatio>
            <Text as="h2" textStyle="subtitle" marginTop="16px" noOfLines={2} fontWeight="bold">
              {article.title}
            </Text>
            <Text noOfLines={2} textStyle="body2" marginTop="8px" fontSize="14px">
              {striptags(article.body).substring(0, 80)}
            </Text>
            <Text textStyle="body2" marginTop="8px" fontSize="14px">
              {formatDate(article.publishedDate)}
            </Text>
          </Link>
        </LinkBox>
      </Box>
    ))}
  </Flex>
);
